import React, { useState, useEffect } from "react";
import { TextInput, Button, Card, Row, Col, Icon } from "react-materialize";
import { isSignIn, resetPassword, signInWithEmail } from "../helpers/auth";

function PasswordResetPage() {
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });

  useEffect(() => {
    if (isSignIn) {
      let emailFromStorage = window.localStorage.getItem("emailForSignIn");
      if (emailFromStorage) {
        setEmail(emailFromStorage);
      }
    }
  }, []);

  const handlePasswordSet = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage({ text: "Passwords do not match.", type: "error" });
      return;
    }

    if (isSignIn) {
      if (!email) {
        setMessage({
          text: "Please provide your email address for confirmation.",
          type: "error",
        });
        return;
      }

      try {
        await signInWithEmail(email);
        await resetPassword(newPassword);
        setMessage({
          text: "Set/Reset passwords successful !",
          type: "success",
        });
        window.localStorage.removeItem("emailForSignIn");
        resetInputs();
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000)
      } catch (error) {
        setMessage({
          text: "Error setting/resetting password: " + error.message,
          type: "error",
        });
      }
    } else {
      setMessage({
        text: "Invalid or expired link. Please request a new reset link.",
        type: "error",
      });
    }
  };

  const resetInputs = () => {
    setEmail("");
    setNewPassword("");
    setConfirmPassword("");
  };

  return (
    <div className="form-container black-text">
      <Row>
        <Col s={12} m={8} l={6} offset="m2 l3">
          <Card className="form-card">
            <h4 className="center-align">Set/Reset Password</h4>

            {message.text && (
              <div className={`message ${message.type}`}>
                <p>{message.text}</p>
              </div>
            )}

            <form onSubmit={handlePasswordSet}>
              <TextInput
                icon={<Icon>email</Icon>}
                email
                label="Email *"
                validate
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={!!window.localStorage.getItem("emailForSignIn")}
              />
              <TextInput
                icon={<Icon>lock</Icon>}
                password
                label="New password *"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <TextInput
                icon={<Icon>lock</Icon>}
                password
                label="Confirm password *"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                s={12}
              />
              <Button className="submit-button" type="submit" waves="light">
                Set/Reset Password<Icon right>send</Icon>
              </Button>
            </form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default PasswordResetPage;
